<template>
  <div class="PcBox">
    
    <HeadTopHome />
    <div style="marginTop: 130px;">
      <GoKS />
    </div>
   
    <div style="marginTop: 130px;">
      <PCVideo />
    </div>
    <Prologue />
    <div 
      class="pcEboXHome-img-wrap" 
      v-lazy-container="{ selector: 'img', 
      error: 'https://mediakit.enabot.com/eboX/img/common/pc_ebabot800.png', 
      loading: 'https://mediakit.enabot.com/eboX/img/common/pc_ebabot800.png'}"
    >
      <img data-src="https://mediakit.enabot.com/eboX/img/pc/pcEboXHome@2x.png" alt="">
    </div>
    <div style="paddingTop: 86px;">
      <NavList />
    </div>
    
    
    <!-- <HomeDevices /> -->
   
    <!-- page1 -->
    <vue-lazy-component tagName="div" :timeout="1000">
      <HomeDevices/>
      <!-- <div id="ggggggggg" style="paddingBottom:118px;">
        <GuardianBoxHome ref="GuardianBoxHomeRef" @handleActiveIndex="handleActiveIndex" />
      </div> -->
    </vue-lazy-component>
    <div>
      <div style="marginTop:57px;">
        <img style="width:100%;height:auto;" src="https://mediakit.enabot.com/eboX/img/pc/pc_three_in_one_home_guardian.png" alt="">
      </div>
      <div id="ggggggggg" style="paddingTop:57px;"  class="pc_three_in_one_home_guardian">
        <div class="pc_three_in_one_home_guardian-box">
          <img class="pc_three_in_one_home_guardian-img" src="https://mediakit.enabot.com/eboX/img/pc/pc_home_guardian1.png" alt="">
          
        </div>
        <div class="pc_three_in_one_home_guardian-box">
          <img class="pc_three_in_one_home_guardian-img" src="https://mediakit.enabot.com/eboX/img/pc/pc_home_guardian2.png" alt="">
          
        </div>
        <div class="pc_three_in_one_home_guardian-box">
          <img class="pc_three_in_one_home_guardian-img" src="https://mediakit.enabot.com/eboX/img/pc/pc_home_guardian3.png" alt="">
          
        </div>
      </div>
      <div class="pc_three_in_one_home_guardian-text-box">
        <div @click="handleNewActiveIndex(0)" :class="['pc_three_in_one_home_guardian-text',{'pc_three_in_one_home_guardian-text-active':indexActive===0}]">
          YOUR FAMILY'S PROTECTOR
        </div>
        <div @click="handleNewActiveIndex(1)" :class="['pc_three_in_one_home_guardian-text',{'pc_three_in_one_home_guardian-text-active':indexActive===1}]">
          YOUR FAMILY'S COMPANION
        </div>
        <div @click="handleNewActiveIndex(2)" :class="['pc_three_in_one_home_guardian-text',{'pc_three_in_one_home_guardian-text-active':indexActive===2}]">
          YOUR FAMILY'S PLAYMATE
        </div>
      </div>

      <div style="marginTop: 67px" class="swiper-container3 swiper-no-swiping swiper-container-PChome">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <vue-lazy-component tagName="div" :timeout="2000">
              <PCHomeTabA />
            </vue-lazy-component>
            <!-- <PCHomeTabA /> -->
          </div>
          <div class="swiper-slide">
            <!-- <vue-lazy-component tagName="div" :timeout="4000">
              <PCHomeTabB />
            </vue-lazy-component> -->
            <PCHomeTabB />
          </div>
          <div class="swiper-slide">
            <!-- <vue-lazy-component tagName="div" :timeout="4000">
              <PCHomeTabC />
            </vue-lazy-component> -->
            <PCHomeTabC />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="PCHome-pagination-wrap">
      <span @click="selectSwiperActive(index)" :class="['pagination-span',{'pagination-span-active':index === indexActive}]" v-for="(item,index) in ['1','2','3']" :key="index"></span>
    </div> -->
    <div class="PCHome-pagination-wrap"></div>
    <!-- <vue-lazy-component tagName="div" :timeout="2000">
      <transition name="slide-right" mode="out-in">
        <PCHomeTabA v-show="indexActive === 0" />
      </transition>
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="4000">
      <transition name="slide-right" mode="out-in">
        <PCHomeTabB v-show="indexActive === 1" />
      </transition>
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="4000">
      <transition name="slide-right" mode="out-in">
        <PCHomeTabC v-show="indexActive === 2" />
      </transition>
    </vue-lazy-component> -->
  
    <vue-lazy-component tagName="div" :timeout="3000">
      <GoKS />
      <Footer :ExploreUrl="''"/>
    </vue-lazy-component>
    
  </div>
</template>
<script>
import Swiper from "swiper";
import HeadTopHome from './components/headTopHome.vue'
import NavList from './components/navListBox.vue'
import PCVideo from './components/PCVideo.vue'
import GoKS from './components/goKS'
import Prologue from './components/Prologue.vue'
import HomeDevices from './components/HomeDevices.vue'
// import GuardianBox from './components/guardianBox.vue'
import GuardianBoxHome from './components/guardianBoxHome'
// import Protector from './components/protector.vue'
import PCHomeTabA from './components/PCHomeTabA.vue'
import PCHomeTabB from './components/PCHomeTabB'
import PCHomeTabC from './components/PCHomeTabC'

import Footer from './components/footer.vue'

export default {
  data(){
    return{
      indexActive:0
    }
  },
  components:{
    HeadTopHome,
    NavList,
    GoKS,
    PCVideo,
    PCHomeTabA,
    PCHomeTabB,
    PCHomeTabC,
    Prologue,
    HomeDevices,
    // GuardianBox,
    GuardianBoxHome,
    // Protector,
    Footer
  },
  mounted() {
    this.pcinit3()
  },
  methods: {
    pcinit3() {
      this.SwiperBox3 = new Swiper(".swiper-container-PChome", {
        slidesPerView: 1,
        loop: true, // 循环模式选项
        slideToClickedSlide: true,
        resistanceRatio:0,
        autoHeight: true
      });
    },
    selectSwiperActive(index){
      document.getElementById('ggggggggg').scrollIntoView({ behavior: "instant" });
      setTimeout(()=>{
        this.$refs.GuardianBoxHomeRef.selectSwiperActive(index)
      },200)
      
    },
    handleActiveIndex(index) {
      this.indexActive = index.activeIndex
      this.SwiperBox3.slideToLoop(this.indexActive)
      console.log('this.indexActive',this.indexActive)
    },
    handleNewActiveIndex(index){
      this.SwiperBox3.slideToLoop(index)
      this.indexActive = index
      setTimeout(()=>{
        document.getElementById('ggggggggg').scrollIntoView({ behavior: "smooth" });
      },400)
    }
  },
  
}
</script>
<style lang="scss">
  .PcBox{
    width: 100%;
    margin: 0 auto ;
    background: RGBA(4, 13, 50, 1);
    .pcEboXHome-img-wrap{
      max-width: 1200px;
      margin: 0 auto;
    }
    .pcEboXHome-img{
      width: 100%;
      height: auto;
    }

    .pc_three_in_one_home_guardian{
      max-width: 1200px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: space-between;
      .pc_three_in_one_home_guardian-box{
        width: 30%;
        .pc_three_in_one_home_guardian-img{
          width: 100%;
        }
        
      }
    }
    .pc_three_in_one_home_guardian-text-box{
      position: sticky;
      top: 10px;
      z-index: 10;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .pc_three_in_one_home_guardian-text{
        position: relative;
        cursor: pointer;
        width: 30%;
        padding: 30px 10px;
        // height: 106px;
        font-size: 20px;
        border-radius: 44px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 28px;
        background-color: RGBA(8, 20, 72, 1);
        box-sizing: border-box;
        
      }
      .pc_three_in_one_home_guardian-text:hover{
        // font-size: 21px;
        color: #00fcff;
        transform: scale(1.04);
      }
      .pc_three_in_one_home_guardian-text-active{
        // margin-top: -3px;
        color: #00fcff;
        // transform: scale(1.04);
        // font-size: 21px;
        // border-bottom: 3px solid #00fcff;
      }
      // .pc_three_in_one_home_guardian-text-active::before{
      //   content: '';
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 3px;
      //   background-color: #00fcff;
      // }
    }

    .swiper-container3 {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      list-style: none;
      padding: 0;
      z-index: 1;
      .swiper-slide{
        height:1px;      
      }
      .swiper-slide-active,
      .swiper-slide-duplicate-active {
          // background-color: aqua;
          height:auto
      }
    }
    .PCHome-pagination-wrap{
      max-width: 1200px;
      height: 120px;
      // margin: 120px auto;
      // text-align: center;
      // .pagination-span{
      //   display: inline-block;
      //   width: 16px;
      //   height: 16px;
      //   // background-color: #;
      //   border-radius: 50%;
      //   border: 1px solid #FFFFFF;
      //   margin: 0px 10px 0px 10px;
      //   cursor: pointer;
      // }
      // .pagination-span-active{
      //   background-color: #FFFFFF;
      // }
    }
  }
</style>
